import { Injectable } from '@angular/core';
import { PermissionType } from './permission-type';
import { PermissionBase } from './permissions/base.permissions';
import { PermissionsFactory } from './permissions/factory.permissions';
import { ModulesType } from './modules-type';
import { UserDetailsMainModel } from '../user-details-model';
import { AppServiceService } from '../app-service.service';

@Injectable()
export class PermissionManagerService {

    private permissions: PermissionBase;
    userDetails: UserDetailsMainModel;
    constructor(private appService: AppServiceService) {
        this.appService.userDetails.subscribe((d) => (this.userDetails = d));
    }

    isGranted(permission: PermissionType, moduleName: ModulesType) {
        const permissions = PermissionsFactory.getInstance(moduleName);
        if (permissions) {
            for (let perm of permissions) {
                if (perm === permission) {
                    return true;
                }
            }
        }
        else if (this.appService.getUserAccessLevel() == 1) {
            return true;
        }
        return false;
    }
}